
export interface ApkUpdaterPlugin {
    download(opt: ApkUpdaterDownloadOptions): Promise<AplUpdaterDownloadResult>;

    install(): Promise<AplUpdaterInstallResult>;
}

export interface AplUpdaterDownloadResult {
    success: boolean;
    message: string;
    name: string;
    path: string;
    app: any;
    size: number;
}

export interface AplUpdaterInstallResult {
    success: boolean;
    message: string;
}

export interface ApkUpdaterDownloadOptions {
    url: string;
}

import { registerPlugin } from '@capacitor/core';

export const ApkUpdaterPlugin = registerPlugin<ApkUpdaterPlugin>('ApkUpdaterPlugin');